import Hotkeys from 'react-hot-keys';
import { motion } from 'framer-motion';
import { Radio, Space } from 'antd';
import { useState } from 'react';
import { track } from '../../../../tracking';
import { CloseBtIcon } from './BookLabTestsUtils';

const SelectPaymodeModal: React.FC<{
    closeMe: () => void;
    paymode: string;
    setPaymode: (value: string) => void;
    paymodeArray: [string, string][];
    isInclinicCollectionSelected?: boolean;
}> = ({ closeMe, paymode, setPaymode, paymodeArray, isInclinicCollectionSelected }) => {
    const [selectedPaymode, setSelectedPaymode] = useState(paymode);
    return (
        <Hotkeys keyName="esc">
            <motion.div
                initial={{ opacity: 0 }}
                exit={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                style={{ zIndex: 20 }}
                transition={{ duration: 0.2, ease: 'linear' }}
                className="font-lato select-none"
            >
                <div className="modal-overlay" onClick={closeMe}></div>
                <div className="modal-content w-320 h-278 font-lato font-400 rounded-8">
                    <div className="h-full flex flex-col">
                        <div className="flex items-center justify-between px-16 py-14 bg-neutral-9 rounded-t-8">
                            <p className="font-700 text-16">Select Payment Mode</p>
                            <CloseBtIcon closeMe={closeMe} />
                        </div>

                        <div className="flex-1 text-14 px-16 py-14 overflow-auto space-y-16">
                            <Radio.Group
                                onChange={(e) => setSelectedPaymode(e.target.value)}
                                value={selectedPaymode}
                            >
                                <Space direction="vertical">
                                    {paymodeArray.map((i) => (
                                        <Radio
                                            value={i[0]}
                                            disabled={
                                                isInclinicCollectionSelected && i[0] === 'COD'
                                            }
                                        >
                                            {i[1]}
                                        </Radio>
                                    ))}
                                </Space>
                            </Radio.Group>
                        </div>

                        <div className="flex items-center justify-between px-16 py-9 bg-neutral-9 rounded-b-8">
                            <p className="text-neutral-3 font-700 cursor-pointer" onClick={closeMe}>
                                Cancel
                            </p>
                            <button
                                className="btn--small primary-btn px-16 py-8"
                                onClick={() => {
                                    setPaymode(selectedPaymode);
                                    closeMe();
                                    track('ORDER_MEDICINE_PAYMODE_CHANGE', {
                                        paymode: selectedPaymode,
                                    });
                                }}
                                disabled={!selectedPaymode}
                            >
                                Confirm
                            </button>
                        </div>
                    </div>
                </div>
            </motion.div>
        </Hotkeys>
    );
};

export default SelectPaymodeModal;
